import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './Westport.jpeg';

const WestportPage = () => (
  <CityPage
    city="Westport"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/westport"
    currentPage="WestportPage"
    image={image}
    imageAlt="Boat rentals on Upper Rideau Lake in Westport, Ontario"
    intro="Westport sits at the head of the Rideau Canal system on Upper Rideau Lake — one of the best small-town boating destinations in eastern Ontario. WetRentals connects you with local hosts offering pontoons, Sea-Doos, fishing boats, wake boats, kayaks and more."
    sections={[
      {
        heading: 'Where to boat in Westport',
        body:
          'Upper Rideau Lake opens straight from the village dock with easy access to Sand Lake, Big Rideau and the wider Rideau Canal system. It is calmer, quieter water — perfect for family days, fishing trips and slow scenic cruises.',
      },
      {
        heading: 'What you can rent in Westport',
        body:
          'Pontoon boats for relaxed cruising, fishing boats for bass and lake trout, wake and ski boats, Sea-Doos and Jet Skis, plus kayaks, canoes and paddleboards. Local hosts can deliver to your dock or cottage.',
      },
      {
        heading: 'Why book with WetRentals in Westport',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Westport%2C%20Ontario%2C%20Canada&bounds=45.20%2C-75.80%2C44.55%2C-76.80&mapSearch=true"
    searchLabel="Browse all boat rentals in Westport"
  />
);

export default WestportPage;
